import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./styles/index.scss";

import { PersistGate } from "redux-persist/integration/react";
import { Provider ,connect} from "react-redux";
import { lowerCase as _lowerCase } from "lodash";
import {
  BrowserRouter as Router, Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { store, persistor } from "./store";
import * as actions from "./store/actions";
import CacheBuster from "./utils/cacheBuster";

// subdomain styling
import subdomainStyles from "./subdomainStyles.json"
import {getSubdomain} from "./utils/general";

// components for routing
import HistoryListener from "./components/utils/HistoryListener";
import history from "./components/utils/HistoryGenerator";


// ADMIN
import DistrictAdminScreen from "./components/screens/admin/DistrictScreen";
import UserAdminScreen from "./components/screens/admin/UserScreen";
import ImprovementAdminScreen from "./components/screens/admin/ImprovementScreen";
import PaceProgramScreen from "./components/screens/admin/PaceProgramScreen";
import PaceProgramSpecScreen from "./components/screens/admin/PaceProgramSpecScreen";
import FunderScreen from "./components/screens/admin/FunderScreen";
import FunderSpecScreen from "./components/screens/admin/FunderSpecScreen";
import LoanProductSpecScreen from "./components/screens/admin/LoanProductSpecScreen";
import ImprovementCategoryAdminScreen from "./components/screens/admin/ImprovementCategoryAdminScreen";
import AssetTypeScreen from "./components/screens/admin/AssetTypeScreen";
import BusinessTypeScreen from "./components/screens/admin/BusinessTypeScreen";
import ProjectsScreen from "./components/screens/admin/ProjectsScreen";
import ApplicationsScreen from "./components/screens/admin/ApplicationsScreen";
import TreasuryYieldScreen from "./components/screens/admin/TreasuryYieldScreen";
import SiteDashboard from "./components/screens/admin/DashboardScreen";
import ApplicationTemplateBuilderScreen from "./components/screens/admin/ApplicationTemplateBuilderScreen";
import ApplicationRequirementSpecScreen from "./components/screens/admin/ApplicationRequirementSpecScreen";
import WebhookConfigScreen from "./components/screens/admin/WebhookConfigScreen";
import SubdomainConfigScreen from "./components/screens/admin/SubdomainConfigScreen";
import AdminHomeRouter from "./components/screens/admin/AdminHomeRouter";
import SubdomainScreen from "./components/screens/admin/SubdomainScreen";


// PUBLIC
import HomePage from "./components/screens/public/HomePage";
import SplashScreen from "./components/screens/public/SplashScreen";
import LoginScreen from "./components/screens/public/LoginScreen";
import LeadInputStartScreen from "./components/screens/public/LeadInputStartScreen";
import MapTestScreen from "./components/screens/public/MapTestScreen";
import CreateUser from "./components/screens/public/CreateUser";
import ActivateUser from "./components/screens/public/ActivateUser";
import AboutPage from "./components/screens/public/About";
import CleanfiHome from "./components/screens/public/CleanfiHome";
import ProjectLandingRedirect from "./components/screens/public/ProjectLandingRedirect";

import DynamicHomePage from "./components/screens/public/DynamicHomePage";

// APP
import IndicativeFormFlow from "./components/screens/app/IndicativeFormFlow";
import FundingOptionSelect from "./components/screens/app/FundingOptionSelect";
import ForgotPassword from "./components/screens/public/ForgotPassword";
import IndicativeScreen from "./components/screens/app/IndicativeScreen";
import LoanEstimateScreen from "./components/screens/app/LoanEstimateScreen";
import LoanEstimatePrintableScreen from "./components/screens/app/LoanEstimatePrintableScreen";
import MyProjects from "./components/screens/app/MyProjects";
import EmbeddedApplication from "./components/screens/app/EmbeddedApplication"
import ApplicationFormFlow from "./components/screens/app/ApplicationFormFlow";
import ApplicationView from "./components/screens/app/DynamicApplicationView";
import ApplicationViewPrintable from "./components/screens/app/ApplicationViewPrintable";
// import ApplicationFileUpload from "./components/screens/app/ApplicationFileUpload";
import DynamicApplyFlow from "./components/screens/app/DynamicApplicationFormFlow";
import PPAApplication from "./components/screens/app/PPAApplication";
import EditProfile from "./components/screens/app/Profile";

// WHITE LABEL
import CSSGrantQualificationPage from "./components/screens/whitelabels/CssGrantsProjectLanding";

import PrivateRoute from "./components/utils/PrivateRoute";
import {pullSubdomainConfig} from "./store/calls/subdomainConfig";
import {pullLoanEstimatePageFromCookie} from "./utils/subdomains/configHandlers";
// import ApplicationBid from "./components/screens/app/ApplicationBid";


class App extends React.Component {
  // set subdomain info for partner specific stuff

  setSubdomainParams = () => {

    const subDomain = getSubdomain();

    store.dispatch(
        actions.session.setSubdomainInfo({
          client: subDomain
        })
    );


    this.updateCss(subDomain);
    if (subDomain) this.updateIcon(subDomain);
  };

  updateCss(sub) {
    let elementRules;

    const styleSheets = Array.from(document.styleSheets).filter(
        (styleSheet) => !styleSheet.href || styleSheet.href.startsWith(window.location.origin)
    );




    // for (let i = 0; i < styleSheets[0].cssRules.length; i++) {
    //   if (styleSheets[0].cssRules[i].selectorText === ':root') {
    //     elementRules = styleSheets[0].cssRules[i];
    //   }
    // }
    // import styles values from database
    const subStyles = subdomainStyles?.[sub] || subdomainStyles.default;
    if (subdomainStyles[sub]) {
      // modifying the rule in the stylesheet
      document.documentElement.style.setProperty('--primary-color', `${subdomainStyles[sub].primaryColor}`);
      document.documentElement.style.setProperty('--secondary-color', `${subdomainStyles[sub].secondaryColor}`);
      document.documentElement.style.setProperty('--success-color', `${subdomainStyles[sub].successColor}`);
      document.documentElement.style.setProperty('--logo-dark-src', `${subdomainStyles[sub].logo-dark-src}`);
      document.documentElement.style.setProperty('--logo-dark-src', `${subdomainStyles[sub].logo-dark-src}`);
      document.documentElement.style.setProperty('--homepage-bg', `${subdomainStyles[sub].homepage-bg}`);
    }
  }

  updateIcon (sub) {
    let icon = document.getElementById("favicon")
    icon.href = subdomainStyles[sub]?.icon + ''
  }

  componentDidMount() {
    pullSubdomainConfig()
        .then((res) => document.title = res.subdomain_description + ': Commercial Building Financing')

  }

  getHomePageComponent = () => {

    // if (["cleanfi", "www", null, undefined].includes(getSubdomain())) {
    //   return CleanfiHome
    // } 
      return DynamicHomePage
    
  }



  getLoanEstimatePageComponent = () => {
    const availablePages = {
      "LoanEstimateScreen": LoanEstimateScreen,
      "LoanEstimatePrintableScreen": LoanEstimatePrintableScreen,
      "CSSGrantQualificationPage": CSSGrantQualificationPage
    }


    if (['cssgrants'].includes(getSubdomain())) {
      return CSSGrantQualificationPage
    }
    let page = pullLoanEstimatePageFromCookie()
    if (!page || !availablePages[page]) {
      return LoanEstimateScreen
    }
    return availablePages[page]
  }


  getAdminHomeComponent = () => {

  }



  render() {
    return (
      <div className="App" data-theme="default" id="theme-container">
        <Router sub={this.subDomain}>
          <CacheBuster/>
          <HistoryListener />
          <Provider store={store} >
            <PersistGate loading={null} persistor={persistor}>
              <div className="App">
                <Switch>

                  {/* PUBLIC */}
                  <Route exact path="/" component={this.getHomePageComponent()} />
                  <Route exact path="/home" component={this.getHomePageComponent()} />
                  <Route exact path="/address-search" component={ProjectLandingRedirect} />
                  <Route path="/about" component={AboutPage} />
                  <Route path="/login" component={LoginScreen} />
                  <Route path="/start" component={LeadInputStartScreen} />
                  <Route path="/reset-password" component={ForgotPassword} />
                  <Route path="/create-account" component={CreateUser} />
                  <Route path="/activateuser" component={ActivateUser} />
                  <Route path="/project" component={IndicativeFormFlow} />
                  <Route path="/option" component={FundingOptionSelect} />


                  {/*  APP  */}
                  <Route
                    path="/indicative/:projectLeadId"
                    component={IndicativeScreen}
                  />

                  <Route
                    path="/project-estimate/:projectLeadId"
                    component={this.getLoanEstimatePageComponent()}
                  />
                  <Route
                    path="/print-estimate/:projectLeadId"
                    component={LoanEstimatePrintableScreen}
                  />
                  <Route
                    path="/share-estimate"
                    component={this.getLoanEstimatePageComponent()}
                  />
                  <Route
                      path="/indicative"
                      component={IndicativeScreen}
                  />
                  <Route
                      path="/my-projects"
                      component={MyProjects}
                  />

                  <PrivateRoute
                    exact
                    path="/admin"
                    component={AdminHomeRouter}
                  />
                  <PrivateRoute
                    path="/admin/communities"
                    component={DistrictAdminScreen}
                  />
                  <PrivateRoute
                    path="/admin/users"
                    component={UserAdminScreen}
                  />
                  <PrivateRoute
                    exact
                    path="/admin/improvements"
                    component={ImprovementAdminScreen}
                  />
                  <PrivateRoute
                    exact
                    path="/admin/improvements/categories"
                    component={ImprovementCategoryAdminScreen}
                  />
                  <PrivateRoute
                    path="/admin/pace-programs/:id"
                    component={PaceProgramSpecScreen}
                  />
                  <PrivateRoute
                    exact
                    path="/admin/pace-programs"
                    component={PaceProgramScreen}
                  />
                  <PrivateRoute
                    exact
                    path="/admin/funders"
                    component={FunderScreen}
                  />
                  <PrivateRoute
                    exact
                    path="/admin/funders/:id"
                    component={FunderSpecScreen}
                  />
                  <PrivateRoute
                    exact
                    path="/admin/funders/:funderId/product/:loanProductId"
                    component={LoanProductSpecScreen}
                  />
                  <PrivateRoute
                    exact
                    path="/admin/business-types"
                    component={BusinessTypeScreen}
                  />
                  <PrivateRoute
                    exact
                    path="/admin/asset-types"
                    component={AssetTypeScreen}
                  />
                  <PrivateRoute
                    exact
                    path="/admin/projects"
                    component={ProjectsScreen}
                  />
                  <PrivateRoute
                      exact
                      path="/admin/applications"
                      component={ApplicationsScreen}
                  />
                  <PrivateRoute
                      exact
                      path="/admin/treasury-yields"
                      component={TreasuryYieldScreen}
                  />
                  <PrivateRoute
                      exact
                      path="/admin/site-dashboard"
                      component={SiteDashboard}
                  />
                  <PrivateRoute
                      exact
                      path="/admin/webhooks"
                      component={WebhookConfigScreen}
                  />

                  <PrivateRoute
                      exact
                      path="/admin/subdomains"
                      component={SubdomainScreen}
                  />
                  <PrivateRoute
                      exact
                      path="/admin/subdomain-config"
                      component={SubdomainConfigScreen}
                  />
                  <PrivateRoute
                      exact
                      path="/admin/app-template/:id"
                      component={ApplicationTemplateBuilderScreen}
                  />
                  {/* <Route */}
                  {/*  exact */}
                  {/*  path="/apply/:id" */}
                  {/*  component={ApplicationFormFlow} */}
                  {/* /> */}

                  {/* APPLICATION ROUTES */}
                   <Route
                      exact
                      path="/application/:id"
                      component={ApplicationView}
                  /> 


                  <Route
                      exact
                      path="/print-application/:id"
                      component={ApplicationViewPrintable}
                  />
                  {/* note dupe. NO id means create new app */}
                  <Route
                      exact
                      path="/apply"
                      component={DynamicApplyFlow}
                  />
                  <Route
                      exact
                      path="/apply/:id"
                      component={DynamicApplyFlow}
                  />
                  <Route
                      exact
                      path="/ppa-apply/:project_id"
                      component={PPAApplication}
                  />
                  <Route
                    exact
                    path="/account/edit"
                    component={EditProfile}
                  />
                  <PrivateRoute
                      exact
                      path="/admin/edit-app-req/:id"
                      component={ApplicationRequirementSpecScreen}
                  />
                  
              

                  {/* TEST ROUTES */}
                  <PrivateRoute
                      exact
                      path="/css-grants-landing"
                      component={CSSGrantQualificationPage}
                  />


                </Switch>
              </div>
            </PersistGate>
          </Provider>
        </Router>
      </div>
    );
  }
}

export default App;
